module.exports = __webpack_public_path__ + "f05275cc14cc3122853dfb5229c81043.jpg";